export function analyticsEventTrigger(eventName, data) {
  window.asos.eventBus.emit(eventName, eventName, data);
}
